import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeModule } from '../home/home.module';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../header/header.module';
import { NewBusinessComponent } from './new-business/new-business.component';
import { SubmissionsModule } from '../submissions/submissions.module';
import { DiceModule } from '../dice/dice.module';

@NgModule({
  declarations: [
    NewBusinessComponent
  ],  
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    HomeModule,
    RouterModule,
    SubmissionsModule,
    DiceModule
  ],
  exports: [
    NewBusinessComponent
  ]
})
export class NewBusinessModule { }
